import { ProjectCode } from '@constants'

import aquaAvatar from '../assets/avatar/aqua-avatar.png'
import dcsAvatar from '../assets/avatar/dcs-avatar.png'
import hmAvatar from '../assets/avatar/hm-avatar.png'
import lmAvatar from '../assets/avatar/lm-avatar.png'
import mnpAvatar from '../assets/avatar/mnp-avatar.png'
import pmAvatar from '../assets/avatar/pm-avatar.png'
import ppAvatar from '../assets/avatar/pp-avatar.png'
import rsAvatar from '../assets/avatar/rs-avatar.png'
import ytAvatar from '../assets/avatar/yt-avatar.png'
import aquaBadge from '../assets/badge/aqua-badge.png'
import dcsBadge from '../assets/badge/dcs-badge.png'
import hmBadge from '../assets/badge/hm-badge.png'
import lmBadge from '../assets/badge/lm-badge.png'
import mnpBadge from '../assets/badge/mnp-badge.png'
import pmBadge from '../assets/badge/pm-badge.png'
import ppBadge from '../assets/badge/pp-badge.png'
import rsBadge from '../assets/badge/rs-badge.png'
import ytBadge from '../assets/badge/yt-badge.png'
import aquaIcon from '../assets/icon/aqua-icon.png'
import dcsIcon from '../assets/icon/dcs-icon.png'
import hmIcon from '../assets/icon/hm-icon.png'
import lmIcon from '../assets/icon/lm-icon.png'
import mnpIcon from '../assets/icon/mnp-icon.png'
import pmIcon from '../assets/icon/pm-icon.png'
import ppIcon from '../assets/icon/pp-icon.png'
import rsIcon from '../assets/icon/rs-icon.png'
import ytIcon from '../assets/icon/yt-icon.png'

export interface BrandAssets {
  avatar: string
  icon: string
  badge: string
}

export const brandImageMap: Partial<Record<ProjectCode, BrandAssets>> = {
  [ProjectCode.DCS]: { avatar: dcsAvatar, icon: dcsIcon, badge: dcsBadge },
  [ProjectCode.LM]: { avatar: lmAvatar, icon: lmIcon, badge: lmBadge },
  [ProjectCode.HM]: { avatar: hmAvatar, icon: hmIcon, badge: hmBadge },
  [ProjectCode.MNP]: { avatar: mnpAvatar, icon: mnpIcon, badge: mnpBadge },
  [ProjectCode.AQUA]: { avatar: aquaAvatar, icon: aquaIcon, badge: aquaBadge },
  [ProjectCode.PP]: { avatar: ppAvatar, icon: ppIcon, badge: ppBadge },
  [ProjectCode.PM]: { avatar: pmAvatar, icon: pmIcon, badge: pmBadge },
  [ProjectCode.YT]: { avatar: ytAvatar, icon: ytIcon, badge: ytBadge },
  [ProjectCode.RS]: { avatar: rsAvatar, icon: rsIcon, badge: rsBadge },
}
